import React from 'react';
import SelectList from 'react-widgets/lib/SelectList';
import { Col, InputGroup, Row } from 'reactstrap';
import {
  ItemContainer,
  ItemContainerFooter,
  ItemContainerHeader,
  ItemContainerText,
} from '../../../components/Item';
import ErrorField from '../../../containers/Fields/ErrorField';
import Indicator, { IndicatorStateOptions } from '../../Indicator';
import InformationButton from '../../Item/InformationButton';

export interface OptionItem {
  id: string;
  display: string;
  code: string;
  data: any;
  exclusive?: boolean;
}

export type SingleSelectInputRenderProps = {
  supportingLink?: React.MouseEventHandler;
  informationText?: string[];
  indicatorState?: IndicatorStateOptions;
  text?: string;
  enabled?: boolean;
  error?: string;
  disabled?: boolean;
  name: string;
  check?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
  options?: OptionItem[];
};

const SingleSelectInput = (props: SingleSelectInputRenderProps) => {
  const {
    text,
    enabled,
    supportingLink,
    informationText,
    indicatorState: state,
    options,
  } = props;
  return enabled === undefined || enabled ? (
    <ItemContainer pulsing={enabled !== undefined}>
      <ItemContainerText text={text}>
        {supportingLink ? <InformationButton onClick={supportingLink} /> : null}
      </ItemContainerText>
      <ItemContainerHeader>
        <div className="d-flex flex-row-reverse justify-content-between">
          {informationText
            ? informationText.map((info, index) => (
                <div key={index} className={'d-inline-flex'}>
                  <em className={'i-information-text'}>{info}</em>
                </div>
              ))
            : null}
        </div>
      </ItemContainerHeader>
      <Row noGutters={true} className="ic-item m-2">
        <Col>
          <InputGroup>
            <SelectList
              name={props.name}
              onBlur={props.onBlur}
              onFocus={props.onFocus}
              onChange={(value?: any) => {
                if (!props.onChange) return;
                props.onChange(value?.code);
              }}
              value={
                options ? options.find(x => x.code === props.value) : undefined
              }
              disabled={props.disabled}
              data={options}
              textField="display"
              valueField="id"
            />
          </InputGroup>
        </Col>
      </Row>
      <ItemContainerFooter>
        <div className="d-flex flex-row-reverse align-items-center ">
          <Indicator state={state} />
          <ErrorField name={props.name} />
        </div>
      </ItemContainerFooter>
    </ItemContainer>
  ) : null;
};
export default SingleSelectInput;
